export const MESSAGE_DISPLAY_TIMEOUT = 7000;
export const ERROR_DISPLAY_TIMEOUT = 15000;

export const ENTER = 'Enter';
export const ESCAPE = 'Escape';
export const FILE = 'file';
export const FOLDER = 'folder';
